import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { translations } from "@/i18n";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("mutatoni_lang") || "en");
  const setLanguage = useCallback((l) => {
    localStorage.setItem("mutatoni_lang", l);
    setLang(l);
  }, []);

  // First visit: open in the visitor's language based on their IP country.
  useEffect(() => {
    if (localStorage.getItem("mutatoni_lang")) return;
    const base = process.env.REACT_APP_BACKEND_URL;
    fetch(`${base}/api/geo/lang`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (d?.language && !localStorage.getItem("mutatoni_lang")) {
          localStorage.setItem("mutatoni_lang", d.language);
          setLang(d.language);
        }
      })
      .catch(() => {});
  }, []);

  const toggle = useCallback(() => setLanguage(lang === "en" ? "es" : "en"), [lang, setLanguage]);
  const t = useCallback((key) => {
    const dict = translations[lang] || translations.en;
    return dict[key] ?? translations.en[key] ?? key;
  }, [lang]);
  return (
    <LanguageContext.Provider value={{ lang, setLanguage, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
